import $ from "jquery";
import "select2";

const select2FromInput = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            input: ".js-input-select2",
        };

        if ($(el.input).length === 0) return;

        $(el.input).select2();
    };

    init();
};

try {
    select2FromInput();
} catch (error) {
    console.error("select2FromInput", error);
}
